import React, { memo } from 'react';

import { Typography } from '@mui/material';

import { useStyles } from './styles';

export interface IControlledErrorProps {
  error: string;
  show: boolean;
  children?: React.ReactNode;
  styleClass?: string;
}

const ControlledError = ({ error, show, children, styleClass = '' }: IControlledErrorProps) => {
  const classes = useStyles();
  return (
    <>
      {children}
      {show && (
        <Typography className={`${classes.errorMessage} ${styleClass}`} color="error" variant="subtitle2" align="left">
          {error}
        </Typography>
      )}
    </>
  );
};

export default memo(ControlledError);
